import styled from "styled-components";

const SlotDiv = styled.div`

color: #fff;
font-size: 10px;
font-weight: 300;
padding-right:2px;
`;
export default SlotDiv;